import { Container } from '@components/Container'
import { PromotionChallengeForm } from '@features/promotionSetting/components/PromotionChallengeForm'
import { DuplicatePromotionChallengePageProps } from './interface'

export function DuplicatePromotionChallengePage({
  initialValues,
  activeCoinOptions,
  challengeCoinOptions,
  handleSubmit,
  handleSaveDraft,
}: DuplicatePromotionChallengePageProps) {
  return (
    <Container>
      <PromotionChallengeForm
        title='สร้างโปรโมชั่น Challenge'
        initialValues={initialValues}
        activeCoinOptions={activeCoinOptions}
        challengeCoinOptions={challengeCoinOptions}
        handleSubmit={handleSubmit}
        handleSaveDraft={handleSaveDraft}
      />
    </Container>
  )
}
